module.exports = __webpack_public_path__ + "static/media/dodgem(11).ffc03546.PNG";